import React, { useMemo } from 'react';
import NestedCommoditySelector from '../../components/NestedCommoditySelector';
import { useCommodities } from '../../../utils/api-hooks/commodity';
import { resolveCommodityName } from '../../../utils/alertCommodity';

// Drop-in for the old steps/CommoditySelector in the alerts wizard: the same
// selector Analytics uses. It emits lowercase names, so resolve back to the
// API-cased name alerts store; a miss, or re-picking the current commodity,
// leaves the selection untouched (the old control deselected on re-click).
const AlertCommoditySelect = ({ selectedCommodity, onCommodityToggle }) => {
  const { commodities } = useCommodities();
  const names = useMemo(
    () => Object.values(commodities || {}).flatMap((items) => (Array.isArray(items) ? items : [])),
    [commodities]
  );

  const handleChange = (next) => {
    const name = resolveCommodityName(names, next);
    const current = String(selectedCommodity || '').trim().toLowerCase();
    if (name && name.toLowerCase() !== current) onCommodityToggle(name);
  };

  return (
    <div className="w-full max-w-[248px]">
      <NestedCommoditySelector
        variant="stacked"
        label="Commodity"
        placeholder="Select..."
        value={selectedCommodity}
        onChange={handleChange}
      />
    </div>
  );
};

export default AlertCommoditySelect;
